import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { themeGet, media } from "sprout-ui-theme";
import Avatar from "@sprout/client-components/dist/Avatar";
import { Flex } from "sprout-ui-primitives";
import { isPresent } from "sprout-lib";
import { sortTopicMembers } from "@sprout/client-lib";
const Wrapper = styled(Flex)`
  a {
    border: 1px solid ${themeGet("colors.white.100")};
  }

  a + a {
    margin-left: -6px;
  }
`;
const OtherLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  background: ${themeGet("colors.grey.200")};
  border-radius: 50%;

  font-size: ${themeGet("fontSizes.1")}px;

  ${media.target("pointer")} {
    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    color: ${themeGet("colors.black.60")};
  }
`;
const TopicPageViewsTopicTopicMembers = (props)=>{
    const { topicMembers , memberCount , rootURL  } = props;
    const sortedTopicMembers = useMemo(()=>{
        return sortTopicMembers(topicMembers).map((topicMember)=>topicMember.user).filter(isPresent).slice(0, 3);
    }, [
        topicMembers
    ]);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        alignItems: "center",
        justifyContent: "center",
        mt: -1,
        mb: 5,
        children: [
            sortedTopicMembers.map((topicMember)=>/*#__PURE__*/ _jsx(Avatar, {
                    user: topicMember,
                    size: 32,
                    navigable: true
                }, topicMember.nodeId)),
            memberCount > 1 && /*#__PURE__*/ _jsx(OtherLink, {
                to: `${rootURL}/members`,
                children: memberCount
            })
        ]
    });
};
export default TopicPageViewsTopicTopicMembers;
